import React from "react";
import { Global, css } from "@emotion/react";
import { cursor } from "../styles/variables/Cursors";

const GlobalStyles = () => (
  <Global
    styles={css`
      body {
        margin: 0;
        ${cursor("auto")};
        &.disable-scroll {
          overflow: hidden;
        }
      }

      #___gatsby {
        margin: 0;
        font-size: 18px;
        font-family: "univers-light", sans-serif;
        line-height: 1.4em;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow-x: hidden;
        color: rgba(33, 23, 3, 1);
        box-sizing: border-box;
        margin: 0;
      }

      a,
      a:visited {
        color: black;
        text-decoration: none;
      }

      button {
        padding: 0px;

        &:hover,
        &:focus {
          outline: none;
        }
      }

      img {
        max-width: 100%;
      }
    `}
  />
);

export default GlobalStyles;
